import { OnlineStockMessage } from "./OnlineStockMessage";
import { OnlineStockWithChecking } from "./OnlineStockWithChecking";

type Props = {
  skuId: string;
  isInStoreOnly: boolean;
  isAvailableToOrderOrPreOrder: boolean;
  supplierDirectMessage: string | undefined;
  variantIsSelected: boolean;
  stockApiBaseUrl: string;
  stockApiKey: string;
};

export function OnlineStock({
  skuId,
  isInStoreOnly,
  isAvailableToOrderOrPreOrder,
  supplierDirectMessage,
  variantIsSelected,
  stockApiBaseUrl,
  stockApiKey,
}: Props) {
  if (!variantIsSelected || !isAvailableToOrderOrPreOrder || isInStoreOnly) {
    return <OnlineStockMessage message={null} busy={false} />;
  }

  if (supplierDirectMessage) {
    return <OnlineStockMessage message={supplierDirectMessage} busy={false} />;
  }

  return (
    <OnlineStockWithChecking
      skuId={skuId}
      stockApiBaseUrl={stockApiBaseUrl}
      stockApiKey={stockApiKey}
    />
  );
}
